import gumMatrixDB from "../db/gumMatrixDB";
import stageDB from "../db/stageDB";
import gumModel from "../model/gumModel";

const getGumModelByStageNumberAndToothGumType = (stageNumber, toothGumType) => {
  const stageDO = stageDB.getStageDOFromStageNumberAndToothGumType(
    stageNumber,
    toothGumType
  );

  const { activeStageNumber } = stageDO;
  const gumModelDO = gumModel.getGumModelByStageNumberAndToothGumType(
    activeStageNumber,
    toothGumType
  );

  if (gumModelDO) {
    return gumModelDO.model;
  }

  throw new Error("Gum model not found");
};

const getGumMatrixByStageNumberAndToothGumType = (
  stageNumber,
  toothGumType
) => {
  const stageDO = stageDB.getStageDOFromStageNumberAndToothGumType(
    stageNumber,
    toothGumType
  );

  const { activeStageNumber } = stageDO;

  const gumMatrixDO = gumMatrixDB.getGumMatrixDOByStageNumberAndToothGumType(
    activeStageNumber,
    toothGumType
  );

  if (gumMatrixDO) {
    return gumMatrixDO.gumMatrix;
  }

  throw new Error("Gum matrix not found");
};

export default {
  getGumModelByStageNumberAndToothGumType,
  getGumMatrixByStageNumberAndToothGumType,
};
